import { render, staticRenderFns } from "./Box-One-Column.vue?vue&type=template&id=7c497e76&scoped=true&"
import script from "./Box-One-Column.vue?vue&type=script&lang=js&"
export * from "./Box-One-Column.vue?vue&type=script&lang=js&"
import style0 from "./Box-One-Column.vue?vue&type=style&index=0&id=7c497e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c497e76",
  null
  
)

export default component.exports